import {
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ReactElement } from "react";

import { PromptTemplateScope } from "../../../types/prompt-template";
import { SCOPE_DISPLAY_NAMES } from "../constants";

interface ScopeSelectFieldProps {
  scope: PromptTemplateScope[];
  error?: string;
  onScopeChange: (value: PromptTemplateScope[]) => void;
}

const ScopeSelectField = ({ scope, error, onScopeChange }: ScopeSelectFieldProps): ReactElement => (
  <Grid size={{ xs: 12, sm: 6 }}>
    <FormControl fullWidth error={!!error} required>
      <InputLabel>Scope</InputLabel>
      <Select
        multiple
        value={scope || []}
        label="Scope"
        input={<OutlinedInput label="Scope" />}
        onChange={(e): void => onScopeChange(e.target.value as PromptTemplateScope[])}
        renderValue={(selected: PromptTemplateScope[]): string =>
          selected.map(v => SCOPE_DISPLAY_NAMES[v]).join(", ")
        }
      >
        {(Object.entries(SCOPE_DISPLAY_NAMES) as [PromptTemplateScope, string][]).map(([value, label]) => (
          <MenuItem key={value} value={value}>
            <Checkbox checked={(scope || []).includes(value)} />
            <ListItemText primary={label} />
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  </Grid>
);

export default ScopeSelectField;
